import ProductImagesList from './ProductImagesList'

export default ProductImagesList
